import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterShip from '@/router/ship'
import RouterAttend from '@/router/attend'

const routes = () => {
    let route
    switch (window.location.hostname) {
        case process.env.VUE_APP_SHIP_DOMAIN:
        case 'localhost':
            route = RouterShip
            break
        case process.env.VUE_APP_ATTEND_DOMAIN:
            route = RouterAttend
            break
    }
    return route
}

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: routes(),
})

/**
 * Setting Global Router Options.
 */
router.beforeEach((to, from, next) => {
    // console.log('to',to)
    // console.log('from',from)
    if (from.path == '/' && !from.name) {
        console.log('MARITIME7 全体で初回だけの処理')
    }
    next()
})
router.afterEach((to, from) => {
    //
})

export default router
